export enum Color {
	Red,
	Blue,
	Green,
	Orange,
	Grey,
	Teal,
	TransparentAndGreen,
	TransparentAndBlue,
	TransparentAndRed,
	TransparentAndGrey
}



// WEBPACK FOOTER //
// ./src/shared/models/color.ts